import { Box, Button } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { dataGridStyle } from "../../../../theme";
import { useNavigate } from "react-router-dom";

const TableADV = ({ responseApi, selectedTipo, filter, setDetailSelected, refDetail }) => {
  const navigate = useNavigate()
  const [dati, setDati] = useState([]);
  const [charged, setCharged] = useState(false)

  useEffect(() => {
    try {
      if (responseApi) {
        const transformedData = responseApi.map((item) => ({
          id:
            item._id.dettaglio +
            item._id.ipSource +
            item._id.ipDestination +
            item._id.timeStamp,
          tipo: item._id.tipo,
          dettaglio: item._id.dettaglio,
          ipSource: item._id.ipSource,
          ipDestination: item._id.ipDestination,
          timeStamp: item._id.timeStamp,
          count: parseInt(item.count),
        }));
        setDati(transformedData);
        setCharged(true);
      }
      else {
        setDati([])
        setCharged(true);
      }
    } catch (error) {
      console.error(error);
      setCharged(true);
    }
  }, [responseApi]);


  const handleRedirectCritical = (details, clickedData, ipSource, ipDestination) => {
    window.sessionStorage.setItem("selectedTab", "Critical");
  
    let url = "";
  
    // Aggiungi solo i parametri che sono stati passati
    if (details) url += `exact_details=${encodeURIComponent(details)}&`;
    if (clickedData) url += `advtimeStamp=${encodeURIComponent(clickedData)}&`;
    if (ipSource) url += `ipSource=${encodeURIComponent(ipSource)}&`;
    if (ipDestination) url += `ipDestination=${encodeURIComponent(ipDestination)}&`;
  
    // Rimuovi l'ultimo "&" se presente
    url = url.endsWith('&') ? url.slice(0, -1) : url;
  
    if (window.sessionStorage.getItem('type') === 'reseller') {
      navigate(`/reseller/myC/critical?${url}`);
    } else {
      window.location.href = `/user/security/critical?${url}`;
    }
  };
  
  const handleRedirectHigh = (details, clickedData, ipSource, ipDestination) => {
    window.sessionStorage.setItem("selectedTab", "High");
  
    let url = "";
  
    if (details) url += `exact_details=${encodeURIComponent(details)}&`;
    if (clickedData) url += `advtimeStamp=${encodeURIComponent(clickedData)}&`;
    if (ipSource) url += `ipSource=${encodeURIComponent(ipSource)}&`;
    if (ipDestination) url += `ipDestination=${encodeURIComponent(ipDestination)}&`;
  
    url = url.endsWith('&') ? url.slice(0, -1) : url;
  
    if (window.sessionStorage.getItem('type') === 'reseller') {
      navigate(`/reseller/myC/high?${url}`);
    } else {
      window.location.href = `/user/security/high?${url}`;
    }
  };
  
  const handleRedirectAlert = (details, clickedData, ipSource, ipDestination) => {
    window.sessionStorage.setItem("selectedTab", "Alert");
  
    let url = "";
  
    if (details) url += `exact_details=${encodeURIComponent(details)}&`;
    if (clickedData) url += `advtimeStamp=${encodeURIComponent(clickedData)}&`;
    if (ipSource) url += `ipSource=${encodeURIComponent(ipSource)}&`;
    if (ipDestination) url += `ipDestination=${encodeURIComponent(ipDestination)}&`;
  
    url = url.endsWith('&') ? url.slice(0, -1) : url;
  
    if (window.sessionStorage.getItem('type') === 'reseller') {
      navigate(`/reseller/myC/alert?${url}`);
    } else {
      window.location.href = `/user/security/alert?${url}`;
    }
  };
  
  const handleRedirectAnomalies = (details, clickedData, ipSource, ipDestination) => {
    window.sessionStorage.setItem("selectedTab", "Movements");
  
    let url = "";
  
    if (details) url += `exact_details=${encodeURIComponent(details)}&`;
    if (clickedData) url += `advtimeStamp=${encodeURIComponent(clickedData)}&`;
    if (ipSource) url += `ipSource=${encodeURIComponent(ipSource)}&`;
    if (ipDestination) url += `ipDestination=${encodeURIComponent(ipDestination)}&`;
  
    url = url.endsWith('&') ? url.slice(0, -1) : url;
  
    if (window.sessionStorage.getItem('type') === 'reseller') {
      navigate(`/reseller/myC/movements?${url}`);
    } else {
      window.location.href = `/user/security/movements?${url}`;
    }
  };
  
  const handleRedirectThreatsInt = (details, clickedData, ipSource, ipDestination) => {
    window.sessionStorage.setItem("selectedTab", "Threat Intelligence");
  
    let url = "";
  
    if (details) url += `exact_details=${encodeURIComponent(details)}&`;
    if (clickedData) url += `advtimeStamp=${encodeURIComponent(clickedData)}&`;
    if (ipSource) url += `ipSource=${encodeURIComponent(ipSource)}&`;
    if (ipDestination) url += `ipDestination=${encodeURIComponent(ipDestination)}&`;
  
    url = url.endsWith('&') ? url.slice(0, -1) : url;
  
    if (window.sessionStorage.getItem('type') === 'reseller') {
      navigate(`/reseller/myC/threat-intelligence?${url}`);
    } else {
      window.location.href = `/user/security/threat-intelligence?${url}`;
    }
  };
  
  const handleLinkClick = (highlightDettaglio, tipo, clickedData, ipSource, ipDestination) => {
    if (tipo === 1) {
      handleRedirectCritical(highlightDettaglio, clickedData, ipSource, ipDestination);
    } else if (tipo === 0) {
      handleRedirectHigh(highlightDettaglio, clickedData, ipSource, ipDestination);
    } else if (tipo === 2) {
      handleRedirectAlert(highlightDettaglio, clickedData, ipSource, ipDestination);
    } else if (tipo === 3) {
      handleRedirectAnomalies(highlightDettaglio, clickedData, ipSource, ipDestination);
    } else if (tipo === 4) {
      handleRedirectThreatsInt(highlightDettaglio, clickedData, ipSource, ipDestination);
    }
  };
  

  const columns =
    responseApi ?
      [
        {
          field: "count",
          headerName: "COUNT",
          maxWidth: 100,
          type: "number",
          format: (value) => value.toString(),
          headerAlign: "center",
          align: "center",
        },
        ...( filter.smartFilter || (filter.dateFrom || filter.dateTo )  ? [{
          field: "timeStamp",
          headerName: "Date",
          flex: 1,
          width: 100,
          headerAlign: "left",
          align: "left",
        }] : []),
        ...(filter.ip1 || filter.nip1 || filter.subnet  ? [{
          field: "ipSource",
          headerName: "IP Source",
          width: 100,
          headerAlign: "left",
          align: "left",
        }] : []),
        ...(filter.ip2 || filter.nip2 || filter.subnet ? [{
            field: "ipDestination",
            headerName: "IP Destination",
            width: 100,
            headerAlign: "left",
            align: "left",
          }] : []),
        {
          field: "tipo",
          headerName: "Type",
          width: 100,
          headerAlign: "left",
          align: "left",
          renderCell: (params) => {
            switch (params.value) {
              case 0: return <div style={{ color: '#FEA51D' }}>High</div>
              case 1: return <div style={{ color: '#931A1D' }}>Critical</div>
              case 2: return <div style={{ color: '#D1C167' }}>Alert</div>
              case 3: return <div>Movements</div>
              case 4: return <div>Intelligence</div>
              default: return null;
            }
          }
        },
        /*...( typeof responseApi[0]._id === 'string' ? [{*/
        {
          field: "dettaglio",
          headerName: "DETAILS",
          flex: 1,
          minWidth: 500,
          headerAlign: "left",
          align: "left",
          cellClassName: "scrollableCell",
          renderCell: (params) => {
            let cellStyle = {};
            const cellValueLower = params.value.toLowerCase();
            if (
              cellValueLower.includes("malware ") ||
              cellValueLower.includes("metasploit ") ||
              cellValueLower.includes("zerologon ") ||
              cellValueLower.includes("ernalblue ") ||
              cellValueLower.includes("eternalblue ") ||
              cellValueLower.includes("mirai ") ||
              cellValueLower.includes("cobalt ") ||
              cellValueLower.includes("wannacry ") ||
              cellValueLower.includes("reverse shell ") ||
              cellValueLower.includes("mware ")
            ) {
              cellStyle = { color: "red" };
            } else if (
              cellValueLower.includes("scan ") ||
              cellValueLower.includes("mining ") ||
              cellValueLower.includes("powershell ") ||
              cellValueLower.includes("pivot ") ||
              cellValueLower.includes("shellcode ")
            ) {
              cellStyle = { color: "#D1C266" };
            } else if (
              cellValueLower.includes("trojan ") ||
              cellValueLower.includes("system32 ") ||
              cellValueLower.includes("hkey ") ||
              cellValueLower.includes("bin ") ||
              cellValueLower.includes("sh ") ||
              cellValueLower.includes("cve ") ||
              cellValueLower.includes("polymor ") ||
              cellValueLower.includes("nbios ") ||
              cellValueLower.includes("buffer ") ||
              cellValueLower.includes("exploit ")
            ) {
              cellStyle = { color: "orange" };
            }
            return (
              <div style={{ ...cellStyle, width: "auto", alignContents: "left", alignContent: "left" }}>
                {params.value}
              </div>
            );
          }
        },
        {
          field: "main-table",
          headerName: "MAIN TABLE",
          headerAlign: "center",
          maxWidth: 100,
          align: "center",
          renderCell: (params) => (
            <Button
              sx={{
                backgroundColor: "#2d2d2d !important",
                color: "#eaeaea !important",
                fontWeight: 900,
                "&:hover": {
                  backgroundColor: "#eaeaea !important",
                  color: "#131C2D !important",
                },
              }}
              onClick={() => {

                handleLinkClick(params.row.dettaglio, params.row.tipo, params.row.timeStamp, params.row.ipSource, params.row.ipDestination)
              }}
            >
              Main Table
            </Button>
          ),
        },
      ] :
      []



  return (
    <Box
      height="100%"
      width="100%"
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <DataGrid
          sx={dataGridStyle}
          rows={dati}
          columns={columns}
          slots={{ toolbar: GridToolbar }}
          loading={!charged}
          slotProps={{
            toolbar: {
              printOptions: { disableToolbarButton: true },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default TableADV;


/*
{
  onRowClick={(params, event) => {
    refDetail.current.scrollIntoView({ behavior: 'smooth' });
    setDetailSelected(params.row.dettaglio)
  }}
}

*/
